import * as Config from '../../../../../../config';
import React from 'react';
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import Content from '../../../../common/Content';
import SubMenu from '../../../../common/SubMenu';
import GridGenres from '../../../../content/grid/GridGenres';
import GridGenresV2 from '../../../../content/grid/GridGenresV2';

import usePageScroll from '../../../../../../hooks/usePageScroll';
import useCustomGenres from '../../hooks/useCustomGenres';

import './Container.css';

function ConnectedContainer({ user, dimension }) {
  let { url } = useRouteMatch();
  const { width, height } = dimension;
  const { formatTitle, getMainGenre, isUpdated } = useCustomGenres();

  const checkValidCustom = (track, stack, isFavorite) => {
    let stateAllowed = false;

    let mainGenre = getMainGenre(track.genres, track.slug);
    if (mainGenre) {
      track.genres = [mainGenre]
    }

    const check = (base, genre) => {
      formatTitle(track);
      track.name += ` ${mainGenre.name}`;
      track.category = track.name;
      if (!stack.some( y => y.genres[0].id === mainGenre.id) && mainGenre.id === genre.id) {
        base = true;
        track.isUpdated = isUpdated(track.category, track.change_date)
      }
      return base;
    }

    if (isFavorite && user) {
      stateAllowed = [...user.genres].reduce((base, genre) => {
        return check(base, genre);
      }, false)
    } else if (!isFavorite && mainGenre) {
      stateAllowed = check(stateAllowed, mainGenre);
    }
    
    return stateAllowed;
  }

  const customBestNew = (isFavorite = false) => (base, x, i) => {
    if (!x.name.toLowerCase().includes('hype') && !x.name.toLowerCase().includes('independent')) {
      if (checkValidCustom(x, base, isFavorite)) {
        base.push(x);
      }
    }
    return base;
  }

  // const customBestOf = (searchByCustom = false) => {
  //   return customBestNew(searchByCustom);
  // }

  const filterByCustomFavorite = (isFavorite = false) => (base, x, i) => {
    if (checkValidCustom(x, base, isFavorite)) {
      base.push(x);
    }
    return base;
  }

  let { onScroll } = usePageScroll();

  return (
    <div className={`dig-deeper-page`} style={{ height }} onScroll={onScroll}>
      <Content name={`Dig Deeper`} isSticky={true} 
        stickyClassName={`sticky-menu-dig-deeper`}
        contentClassName={`content-dig-deeper`}
        styleHeader={{width: width + (Config.CONTENT_PAD * 2)}}
        subContent={(
          <div className={`flexRow slider-menu dig-deeper-menu`}>
            <SubMenu to={`${url}/best-new`} or={`${url}`} label={`Best New`} />
            <SubMenu to={`${url}/best-new-hype`} label={`Best New Hype`} />
            {/* <SubMenu to={`${url}/best-of`} label={`Best Of`} /> */}
            <SubMenu to={`${url}/the-shortlist`} label={`The Shortlist`} />
            {/* <SubMenu to={`${url}/warm-up-essentials`} label={`Warm Up Essentials`} /> */}
            <SubMenu to={`${url}/dancefloor-essentials`} label={`Dancefloor Essentials`} />
            <SubMenu to={`${url}/closing-essentials`} label={`Closing Essentials`} />
            <SubMenu to={`${url}/after-hours-essentials`} label={`After Hours Essentials`} />
            <SubMenu to={`${url}/crate-diggers`} label={`Crate Diggers`} />
            <SubMenu to={`${url}/secret-weapons`} label={`Secret Weapons`} />
            {/* <SubMenu to={`${url}/independent-artists`} label={`Independent Artists`} /> */}
          </div>
        )}
      >
        <Switch>
          <Route exact path={[`${url}`, `${url}/best-new`]}>
            { (user && user.genres_ids && user.genres_ids.length) > 0 && (
              <GridGenresV2 
                title={`Favourite Genres`}
                id={`best-new-favorites`} 
                width={width}
                height={220}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=150&dj_id=36047&genre_id=${user.genres_ids.join(',')}&name=Best New&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:&updated=${dayjs().subtract(20, 'day').format(`YYYY-MM-DD`)}:`}
                showLoading={true}
                customReduceFormat={customBestNew(true)}
                hasPagination={true}
                showTitle={false}
                showAll={false}
                gridStyle={{ margin: '8px 0px 0px 0px' }}
              />
            ) }
            <GridGenresV2 
              title={`All Genres`}
              id={`best-new`} 
              width={width} 
              pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=150&dj_id=36047&name=Best New&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:&updated=${dayjs().subtract(20, 'day').format(`YYYY-MM-DD`)}:`}
              showLoading={true}
              customReduceFormat={customBestNew(false)}
              showTitle={false}
            />
          </Route>
          <Route exact path={`${url}/best-new-hype`}>
            { (user && user.genres_ids && user.genres_ids.length) > 0 && (
              <GridGenresV2 
                title={`Favourite Genres`}
                id={`best-new-hype-favorites`} 
                width={width}
                height={220}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=${user.genres_ids.join(',')}&name=Best New Hype&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:&updated=${dayjs().subtract(20, 'day').format(`YYYY-MM-DD`)}:`}
                showLoading={true}
                customReduceFormat={filterByCustomFavorite(true)}
                hasPagination={true}
                showTitle={false}
                showAll={false}
                gridStyle={{ margin: '8px 0px 0px 0px' }}
              />
            ) }
            <GridGenresV2 
              title={`All Genres`}
              id={`best-new-hype`} 
              width={width} 
              pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Best New Hype&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:&updated=${dayjs().subtract(20, 'day').format(`YYYY-MM-DD`)}:`}
              showLoading={true}
              customReduceFormat={filterByCustomFavorite(false)}
              showTitle={false}
            />
          </Route>
          {/* <Route exact path={`${url}/best-of`}>
            { (user && user.genres_ids && user.genres_ids.length) > 0 && (
              <GridGenres 
                title={`Favourite Genres`}
                id={`best-of-favorites`} 
                width={width}
                height={ Config.GRID_ROW_HEIGHT }
                hasFilters={false}
                perPage={100} 
                pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=${user.genres_ids.join(',')}&name=Best Of&publish_date=${dayjs().format(`YYYY`)}-01-01:${dayjs().format(`YYYY`)}-12-31`}
                className={`grid-chart all`} 
                onlyYear={true}
                showLoading={true}
                customReduceFormat={customBestOf(true)}
              />
            ) }
            <GridGenres 
              id={`best-of`} 
              title={`All Genres`}
              width={width} 
              rowCount={2} 
              height={ Config.GRID_ROW_HEIGHT * 3 }
              hasFilters={false}
              perPage={100} 
              pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=11,5,6,90,1,39,12,89,14,15,92,37,7,93,2,96,81,3,50,91&name=Best Of&publish_date=${dayjs().format(`YYYY`)}-01-01:${dayjs().format(`YYYY`)}-12-31`}
              className={`grid-chart all`} 
              onlyYear={true}
              showLoading={true}
              customReduceFormat={customBestOf(false)}
            />
          </Route> */}
          <Route exact path={`${url}/the-shortlist`}>
            { (user && user.genres_ids && user.genres_ids.length) > 0 && (
              <GridGenresV2 
                title={`Favourite Genres`}
                id={`the-shortlist-favorites`} 
                width={width}
                height={220}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=${user.genres_ids.join(',')}&name=Shortlist&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
                showLoading={true}
                customReduceFormat={filterByCustomFavorite(true)}
                hasPagination={true}
                showTitle={false}
                showAll={false}
                gridStyle={{ margin: '8px 0px 0px 0px' }}
              />
            ) }
             <GridGenresV2 
              title={`All Genres`}
              id={`the-shortlist`} 
              width={width} 
              pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=Shortlist&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
              showLoading={true}
              customReduceFormat={filterByCustomFavorite(false)}
              showTitle={false}
            />
          </Route>
          {/* <Route exact path={`${url}/warm-up-essentials`}>
            { (user && user.genres_ids && user.genres_ids.length) > 0 && (
              <GridGenres 
                title={`Favourite Genres`}
                id={`warm-up-essentials-favorites`} 
                width={width} 
                height={ Config.GRID_ROW_HEIGHT }
                hasFilters={false}
                perPage={100} 
                pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=${user.genres_ids.join(',')}&name=warm-up&publish_date=${dayjs().format(`YYYY`)}-01-01:${dayjs().format(`YYYY`)}-12-31`}
                className={`grid-chart all`} 
                showLoading={true}
                onlyYear={true}
                customReduceFormat={filterByCustomFavorite(false)}
              />
            ) }
            <GridGenres
              title={`All Genres`}
              id={`warm-up-essentials`} 
              width={width} 
              rowCount={2} 
              height={ Config.GRID_ROW_HEIGHT * 3 }
              hasFilters={false}
              perPage={100} 
              pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=11,5,6,90,1,39,12,89,14,15,92,37,7,93,2,96,81,3,50,91&name=warm-up&publish_date=${dayjs().format(`YYYY`)}-01-01:${dayjs().format(`YYYY`)}-12-31`}
              className={`grid-chart all`} 
              showLoading={true}
              onlyYear={true}
            />
          </Route> */}
          <Route exact path={`${url}/dancefloor-essentials`}>
            { (user && user.genres_ids && user.genres_ids.length) > 0 && (
              <GridGenresV2 
                title={`Favourite Genres`}
                id={`dancefloor-essentials-favorites`} 
                width={width}
                height={220}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=${user.genres_ids.join(',')}&name=floor essentials&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
                showLoading={true}
                customReduceFormat={filterByCustomFavorite(true)}
                hasPagination={true}
                showTitle={false}
                showAll={false}
                gridStyle={{ margin: '8px 0px 0px 0px' }}
              />
            ) }
             <GridGenresV2 
              title={`All Genres`}
              id={`dancefloor-essentials`} 
              width={width} 
              pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=floor essentials&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
              showLoading={true}
              customReduceFormat={filterByCustomFavorite(false)}
              showTitle={false}
            />
          </Route>
          <Route exact path={`${url}/closing-essentials`}>
          { (user && user.genres_ids && user.genres_ids.length) > 0 && (
              <GridGenresV2 
                title={`Favourite Genres`}
                id={`closing-essentials-favorites`} 
                width={width}
                height={220}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=${user.genres_ids.join(',')}&name=closing essentials&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
                showLoading={true}
                customReduceFormat={filterByCustomFavorite(true)}
                hasPagination={true}
                showTitle={false}
                showAll={false}
                gridStyle={{ margin: '8px 0px 0px 0px' }}
              />
            ) }
            <GridGenresV2 
              title={`All Genres`}
              id={`closing-essentials`} 
              width={width} 
              pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=closing essentials&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
              showLoading={true}
              customReduceFormat={filterByCustomFavorite(false)}
              showTitle={false}
            />
          </Route>
          <Route exact path={`${url}/after-hours-essentials`}>
            { (user && user.genres_ids && user.genres_ids.length) > 0 && (
              <GridGenresV2 
                title={`Favourite Genres`}
                id={`after-hours-essentials-favorites`} 
                width={width}
                height={220}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=${user.genres_ids.join(',')}&name=after hour&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
                showLoading={true}
                customReduceFormat={filterByCustomFavorite(true)}
                hasPagination={true}
                showTitle={false}
                showAll={false}
                gridStyle={{ margin: '8px 0px 0px 0px' }}
              />
            ) }
            <GridGenresV2 
              title={`All Genres`}
              id={`after-hours`} 
              width={width} 
              pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=after hour&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
              showLoading={true}
              customReduceFormat={filterByCustomFavorite(false)}
              showTitle={false}
            />
          </Route>
          <Route exact path={`${url}/crate-diggers`}>
            { (user && user.genres_ids && user.genres_ids.length) > 0 && (
              <GridGenresV2 
                title={`Favourite Genres`}
                id={`crate-diggers-favorites`} 
                width={width}
                height={220}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=${user.genres_ids.join(',')}&name=crate&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
                showLoading={true}
                customReduceFormat={filterByCustomFavorite(true)}
                hasPagination={true}
                showTitle={false}
                showAll={false}
                gridStyle={{ margin: '8px 0px 0px 0px' }}
              />
            ) }
            <GridGenresV2 
              title={`All Genres`}
              id={`crate-diggers`} 
              width={width} 
              pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=crate&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
              showLoading={true}
              customReduceFormat={filterByCustomFavorite(false)}
              showTitle={false}
            />
          </Route>
          <Route exact path={`${url}/secret-weapons`}>
            { (user && user.genres_ids && user.genres_ids.length) > 0 && (
              <GridGenresV2 
                title={`Favourite Genres`}
                id={`secret-weapons-favorites`} 
                width={width}
                height={220}
                pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=${user.genres_ids.join(',')}&name=secret&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
                showLoading={true}
                customReduceFormat={filterByCustomFavorite(true)}
                hasPagination={true}
                showTitle={false}
                showAll={false}
                gridStyle={{ margin: '8px 0px 0px 0px' }}
              />
            ) }
            <GridGenresV2 
              title={`All Genres`}
              id={`secret-weapons`} 
              width={width} 
              pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&name=secret&publish_date=${dayjs().subtract(1, 'year').format(`YYYY-MM-DD`)}:`}
              showLoading={true}
              customReduceFormat={filterByCustomFavorite(false)}
              showTitle={false}
            />
          </Route>
          <Route exact path={`${url}/independent-artists`}>
            <GridGenres
              title={`All Genres`} 
              id={`independent-artists`} 
              width={width} 
              rowCount={2} 
              height={ Config.GRID_ROW_HEIGHT * 3 }
              hasFilters={false}
              perPage={100} 
              pathApi={`/catalog/charts/?enabled=true&is_published=true&per_page=100&dj_id=36047&genre_id=11,5,6,90,1,39,12,89,14,15,92,37,7,93,2,96,81,3,50,91&name=independent&publish_date=${dayjs().format(`YYYY`)}-01-01:${dayjs().format(`YYYY`)}-12-31`}
              className={`grid-chart all`} 
              showLoading={true}
              onlyYear={true}
            />
          </Route>
        </Switch>
      </Content>
    </div>
  );
}

ConnectedContainer.propTypes = {
  user: PropTypes.object,
  dimension: PropTypes.object
}

const Container = connect(
  state => ({
    user: state.user,
    dimension: state.dimension
  })
)(ConnectedContainer);

export default Container;
